import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { METHOD_TYPES } from 'constants/index'

export const placeBetKenoGameService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/keno-game/place-bet', data, {
    server: microServices.USER_URL
  })
}

export const getMyBetsKenoGameService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/keno-game/my-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}
